<template lang="pug">
#tabela-infos-publica-bndes-pj
    BaseTableHeader(
        :icone-titulo-tabela='iconeTituloTabela',
        :titulo-tabela='tituloTabela'
    )

    div(v-if='items.length > 0')
        el-table(
            :data='paginatedItems',
            style='width: 100%; height: 100%;',
            :default-sort='{ prop: "numeroContrato", order: "ascending" }',
            stripe,
            v-loading='isLoading'
        )
            el-table-column(type='expand')
                template(slot-scope='props')
                    el-descriptions.descricao-item-tabela(
                        :size='"mini"',
                        :column='3',
                        direction='vertical'
                    )
                        el-descriptions-item.has-colon-not(
                            :label="$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.formaDeApoio')"
                        ) {{ formatarTexto(props.row.operacaoDireta_sfm) }}
                        el-descriptions-item.has-colon-not(
                            :label="$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.fonteRecursos')"
                        ) {{ formatarTexto(props.row.fonteRecursos) }}
                        el-descriptions-item.has-colon-not(
                            :label="$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.valorDesembolsado')"
                        ) {{ formatNumberExpanded(props.row.valorDesembolsado_vf) }}
                    el-descriptions.descricao-item-tabela.mt-3(
                        :size='"mini"',
                        :column='5',
                        direction='vertical'
                    )
                        el-descriptions-item.has-colon-not(
                            :label="$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.descricao')"
                        ) {{ props.row.descricaoProjeto }}
            el-table-column(
                :label="$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.contrato')",
                prop='numeroContrato',
                align='left',
                min-width='80px'
            )
            el-table-column(
                :label="$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.data')",
                prop='dataContratacao',
                :formatter='formatarDataTableColumn',
                min-width='80px',
                align='left'
            )
            el-table-column(
                :label="$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.valorContratadoReais')",
                prop='valorContratacao',
                :formatter='formatNumber',
                min-width='100px',
                sortable,
                align='left'
            )
            el-table-column(
                :label="$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.situacao')",
                prop='liquidada',
                align='left',
                min-width='60px'
            )
            el-table-column(
                :label="$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.acoes')",
                align='center',
                min-width='90'
            )
                .template.d-flex.justify-content-center(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='abrirModalDetalhesInfosPublicaBndes(scope.row)'
                            ) {{ $t('mensagens.preAnaliseCredito.informacoesPublicasBndes.verInformacoesDetalhadas') }}
        .d-flex.flex-row.justify-content-between.align-items-center.border-bottom
            .tabela-rodape-somatorio(v-if='dados.bndes.response.docs.length > 0')
                p {{ dados.bndes.response.numFound }} {{ $t('mensagens.preAnaliseCredito.informacoesPublicasBndes.operacoes') }}
            el-pagination(
                v-if='dados.bndes.response.docs.length > 0',
                :page-size='8',
                :pager-count='5',
                layout='prev, pager, next',
                :total='dados.bndes.response.numFound',
                @prev-click='avancarPagina',
                @next-click='voltarPagina',
                @current-change='atualizarPagina'
            )
    el-alert(
        v-else,
        :title="$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.naoHaRegistroParaInformacoesPublicasBndes')",
        type='warning',
        :closable='false'
    )
    BaseModalVisualizarInfos(
        v-if='modalDetalhesInfosPublicaBndes'
        :show='modalDetalhesInfosPublicaBndes',
        width='800px',
        @closeDialog='modalDetalhesInfosPublicaBndes = false; dadosModalDetalhesInfosPublicaBndes = ""'
    )
        slot
            BaseInfoBlock(
                :titulos-info-block="[$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.apoioFormaModalidade'), $t('mensagens.preAnaliseCredito.informacoesPublicasBndes.produto')]",
                :valores-info-block='[dadosModalDetalhesInfosPublicaBndes.tope, dadosModalDetalhesInfosPublicaBndes.produtoBndes]'
            )
            el-divider
            BaseInfoBlock(
                :titulos-info-block="[$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.porte'), $t('mensagens.preAnaliseCredito.informacoesPublicasBndes.naurezaDoCliente')]",
                :valores-info-block='[dadosModalDetalhesInfosPublicaBndes.porteCliente, dadosModalDetalhesInfosPublicaBndes.naturezaCliente]'
            )
            el-divider
            BaseInfoBlock(
                :titulos-info-block="[$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.tipoDeGarantia')]",
                :valores-info-block='[dadosModalDetalhesInfosPublicaBndes.tipoGarantia]'
            )
            el-divider
            BaseInfoBlock(
                :titulos-info-block="[$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.formaDeApoio'), $t('mensagens.preAnaliseCredito.informacoesPublicasBndes.agenteFinanceiroValor')]",
                :valores-info-block='[dadosModalDetalhesInfosPublicaBndes.categoria, [dadosModalDetalhesInfosPublicaBndes.agenteFinanceiro, dadosModalDetalhesInfosPublicaBndes.faixaValorContratacao]]'
            )
            el-divider
            BaseInfoBlock(
                :titulos-info-block="[$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.modalidadeDeApoio'), $t('mensagens.preAnaliseCredito.informacoesPublicasBndes.produtoValor')]",
                :valores-info-block='[dadosModalDetalhesInfosPublicaBndes.reembolsavel, [dadosModalDetalhesInfosPublicaBndes.produtoBndes_sfm, formatValorBRL(dadosModalDetalhesInfosPublicaBndes.valorContratacao)]]'
            )
            el-divider
            BaseInfoBlock(
                :titulos-info-block="[$t('mensagens.preAnaliseCredito.informacoesPublicasBndes.inovacao'), $t('mensagens.preAnaliseCredito.informacoesPublicasBndes.valor')]",
                :valores-info-block='[dadosModalDetalhesInfosPublicaBndes.inovacao]'
            )
</template>

<script>
import formatters from '@/utils/formatters';

import preAnaliseServiceMixin from '@/mixins/PreAnaliseCreditoMixin';

import BaseTableHeader from '@/components/preAnaliseCredito/BaseTableHeader';
import BaseInfoBlock from '@/components/preAnaliseCredito/BaseInfoBlock';
import BaseModalVisualizarInfos from '@/components/preAnaliseCredito/BaseModalVisualizarInfos';

export default {
    name: 'TabelaInfosPublicasBndesPj',

    components: {
        BaseTableHeader,
        BaseInfoBlock,
        BaseModalVisualizarInfos
    },

    mixins: [preAnaliseServiceMixin],

    props: {
        tituloTabela: {
            type: String,
            required: true,
            default: 'Tabela'
        },
        iconeTituloTabela: {
            type: String,
            required: true,
            default: 'mdi mdi-cloud-search-outline'
        },
        dados: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    data() {
        return {
            dadoSelecionado: null,
            items: [],
            paginaAtual: 1,
            itemsPorPagina: 8,
            isLoading: false,
            modalDetalhesInfosPublicaBndes: false,
            dadosModalDetalhesInfosPublicaBndes: ''
        };
    },

    created() {
        this.items = this.dados.bndes.response.docs;
    },

    computed: {
        totalPages() {
            return Math.ceil(this.items.length / this.itemsPorPagina);
        },
        paginatedItems() {
            const startIndex = (this.paginaAtual - 1) * this.itemsPorPagina;
            const endIndex = startIndex + this.itemsPorPagina;
            return this.items.slice(startIndex, endIndex);
        }
    },

    methods: {
        abrirModalDetalhesInfosPublicaBndes(row) {
            this.modalDetalhesInfosPublicaBndes = true;
            this.dadosModalDetalhesInfosPublicaBndes = row;
        },
        formatNumber(row, column, number, index) {
            return formatters.formatNumber(number, 2);
        },
        formatNumberExpanded(number) {
            return formatters.formatNumber(number, 2);
        },
        formatarDataTableColumn(row, column, data, index) {
            return this.mxFormatarData(data);
        },
        formatarTexto(texto) {
            if (!texto) {
                return '- -';
            } else {
                return texto.join(', ');
            }
        },
        formatarTextoJuros(texto) {
            let arrayTextos = [];
            texto.forEach(el => {
                arrayTextos.push(Number(el).toFixed(2));
            });
            return arrayTextos.join(', ');
        },
        voltarPagina() {
            this.handleLoadingTable();
            setTimeout(() => {
                if (this.paginaAtual > 1) {
                    this.paginaAtual--;
                }
            }, 550);
        },
        avancarPagina() {
            this.handleLoadingTable();
            setTimeout(() => {
                if (this.paginaAtual < this.totalPages) {
                    this.paginaAtual++;
                }
            }, 550);
        },
        atualizarPagina(pagina) {
            this.handleLoadingTable();
            setTimeout(() => {
                this.paginaAtual = pagina;
            }, 550);
        },
        handleLoadingTable() {
            this.isLoading = true;
            setTimeout(() => {
                this.isLoading = false;
            }, 500);
        },
        formatValorBRL(valor) {
            return 'R$ ' + formatters.formatNumber(valor, 2);
        }
    }
};
</script>

<style lang="scss">
#tabela-infos-publica-bndes-pj {
    font-family: 'Roboto', 'sans serif' !important;
    border-radius: 5px 5px 0 0 !important;
    height: calc(100vh - 312px);

    h1 {
        border-bottom: 1px solid #359138;
        margin-bottom: 18px;
        width: 100%;
        line-height: 42px;
    }

    i.mdi {
        color: var(--primary);
        margin-right: 10px;
        font-size: 24px;
    }

    .tabela-titulo {
        color: var(--primary);
        font-size: 18px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
    }

    .el-table {
        border: 1px solid #d9d9d9;
        border-radius: 5px;
        height: 100%;

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
            max-height: 100px;
            overflow-y: auto;
        }

        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon>.el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 16px;
            font-weight: 500;
            line-height: 18.75px;
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }

        .el-descriptions-item__label.has-colon::after {
            content: '';
        }
    }

    .tabela-rodape-somatorio p {
        margin-bottom: 0;
        color: var(--primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        padding: 17px 0 15px 21px;
    }

    .el-pagination {
        padding: 16px 75px 16px 0;
        color: #3b3b3b;
    }

    .el-pager li.active {
        color: #00413c;
        font-weight: 600;
        font-size: 15px;
        background: #00413c24;
    }
}
</style>
